export const LOCAL_STORAGE = {
  RANK_IDS: 'rank_ids',
};
